import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AppContext = createContext();

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [appId, setAppId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Извлекаем app_id из URL
    const pathParts = location.pathname.split('/').filter(Boolean);
    
    // Проверяем, является ли первая часть UUID приложения
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    
    if (pathParts.length > 0 && uuidRegex.test(pathParts[0])) {
      setAppId(pathParts[0]);
    } else {
      // Если мы на поддомене app.realgram.ru без app_id, редиректим на основной домен
      if (window.location.hostname.startsWith('app.')) {
        window.location.href = window.location.href.replace('app.', '');
      }
      setAppId(null);
    }
  }, [location, navigate]);

  const value = {
    appId,
    setAppId,
    getBasePath: () => appId ? `/${appId}` : '',
    getApiHeaders: () => appId ? { 'X-App-Id': appId } : {},
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};